import { Location } from 'history'

import RecaptchaLayout from '@/app/component/layout/recaptcha-page'
import { AuthGuard, AuthHeader } from '@/app/module/auth'
import Invitation from '@/app/module/auth/component/invitation'
import Notifications from '@/app/module/notifications'
import { MatchProps } from '@/app/types'

type Props = {
  name: string
  location: Location
  match: MatchProps
}

export default function CheckInvitationPage(props: Props) {
  const { name, match, location } = props
  const params = new URLSearchParams(location.search)
  const id = params.get('id')
  return (
    <AuthGuard url={match.url} path={match.path}>
      <RecaptchaLayout title="Invitation - engageSPARK">
        <AuthHeader currentPage={name} />
        <Invitation invitationToken={id || ''} url={match.url} />
        <Notifications />
      </RecaptchaLayout>
    </AuthGuard>
  )
}
